<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Bank List</h1>
    <getBankApprove />
  </v-card>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import getBankApprove from "@/components/back-office/ManagerUserManage/BankListApprove.vue";
import moment from "moment";
export default {
  components: {
    getBankApprove,
  },
  computed: {
    ...mapState({
      setBankById: (state) => state.banklist.setStatus,
      countNumber: (state) => state.banklist.getCountApprove,
    }),
  },
  methods: {
    ...mapActions({
      getbankDetail: "banklist/fetchBankByid",
    }),
  },
  async created() {
    this.loadingMessage = true;
    await this.$store.dispatch("banklist/fetchBanklist");
    await this.$store.dispatch("banklist/GetCountApproveBank");
    this.loadingMessage = false;
  },
};
</script>
